module.exports = "<div class=\"row org-row\" data-uso-id=\"{%- optional.usoId %}\"> <div class=col-xs-3> <div class=q-marg-vert-xxs> {%- orgName %} </div> </div> <div class=col-xs-7> <div class=q-marg-vert-xxs> {%- facilitiesCount %} </div> </div> <div class=\"col-xs-2 q-text-center\"> <a class=\"q-close-btn remove-org\" id=\"{%- orgId %}\"><i class=\"fa fa-times\"></i></a> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/teamMembers/html/orgView.html
// module id = 1437
// module chunks = 1